// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_calendarSync__TN5Xw {
  display: flex;
  align-items: center;
  gap: 4px;
}

.styles_syncButton__qJfSf,
.styles_providerButton__YTRP6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.styles_syncButton__qJfSf svg,
.styles_providerButton__YTRP6 svg {
  width: 18px;
  height: 18px;
}
.styles_syncButton__qJfSf:hover,
.styles_providerButton__YTRP6:hover {
  background: rgba(0, 0, 0, 0.05);
}

.styles_syncButton__qJfSf svg {
  color: #64748b;
}
.styles_syncButton__qJfSf.styles_spinning__UxE8\\+ svg {
  animation: styles_spin__\\+\\+AKe 1s linear infinite;
  color: #3b82f6;
}

.styles_providerIcons__t4GFz {
  display: flex;
  gap: 4px;
  animation: styles_slideIn__X1wWD 0.15s ease-out;
}

.styles_providerButton__YTRP6.styles_connected__uP0VG svg {
  color: #3b82f6;
}
.styles_providerButton__YTRP6.styles_disconnected__EtQF0 svg {
  color: #9ca3af;
  opacity: 0.6;
}
.styles_providerButton__YTRP6.styles_disconnected__EtQF0:hover svg {
  opacity: 1;
}

@keyframes styles_spin__\\+\\+AKe {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes styles_slideIn__X1wWD {
  from {
    opacity: 0;
    transform: translateX(-8px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.styles_toast__MsxRD {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  color: #374151;
  z-index: 10001;
  animation: styles_slideUp__PAn\\+v 0.2s ease-out;
}

@keyframes styles_slideUp__PAn\\+v {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/calendar-sync/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAAF;AAEE;;EACE,WAAA;EACA,YAAA;AACJ;AAEE;;EACE,+BAAA;AACJ;;AAIE;EACE,cAAA;AADJ;AAIE;EACE,kDAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,QAAA;EACA,+CAAA;AAHF;;AAOE;EACE,cAAA;AAJJ;AAOE;EACE,cAAA;EACA,YAAA;AALJ;AAQE;EACE,UAAA;AANJ;;AAUA;EACE;IAAO,uBAAA;EANP;EAOA;IAAK,yBAAA;EAJL;AACF;AAMA;EACE;IACE,UAAA;IACA,2BAAA;EAJF;EAMA;IACE,UAAA;IACA,wBAAA;EAJF;AACF;AAOA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,+CAAA;AALF;;AAQA;EACE;IACE,UAAA;IACA,4CAAA;EALF;EAOA;IACE,UAAA;IACA,yCAAA;EALF;AACF","sourcesContent":["@import \"mixins\";\n.calendarSync {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.syncButton,\n.providerButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: transparent;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n  }\n}\n\n.syncButton {\n  svg {\n    color: #64748b;\n  }\n\n  &.spinning svg {\n    animation: spin 1s linear infinite;\n    color: #3b82f6;\n  }\n}\n\n.providerIcons {\n  display: flex;\n  gap: 4px;\n  animation: slideIn 0.15s ease-out;\n}\n\n.providerButton {\n  &.connected svg {\n    color: #3b82f6;\n  }\n\n  &.disconnected svg {\n    color: #9ca3af;\n    opacity: 0.6;\n  }\n\n  &.disconnected:hover svg {\n    opacity: 1;\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  padding: 12px 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  color: #374151;\n  z-index: 10001;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarSync": `styles_calendarSync__TN5Xw`,
	"syncButton": `styles_syncButton__qJfSf`,
	"providerButton": `styles_providerButton__YTRP6`,
	"spinning": `styles_spinning__UxE8+`,
	"spin": `styles_spin__++AKe`,
	"providerIcons": `styles_providerIcons__t4GFz`,
	"slideIn": `styles_slideIn__X1wWD`,
	"connected": `styles_connected__uP0VG`,
	"disconnected": `styles_disconnected__EtQF0`,
	"toast": `styles_toast__MsxRD`,
	"slideUp": `styles_slideUp__PAn+v`
};
export default ___CSS_LOADER_EXPORT___;
